(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hrb-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  document.querySelectorAll('.hrb-brands-menu[open], .hrb-mobile-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = event.target.closest('.hrb-brands-menu[open], .hrb-mobile-menu[open]');
  if (menu) {
    menu.open = false;
    menu.querySelector('summary').focus();
    event.stopPropagation();
  }
});
document.addEventListener('toggle', (event) => {
  if (!event.target.matches('.hrb-brands-menu[open]')) return;
  const nav = event.target.closest('.hrb-navigation');
  nav.querySelectorAll('.hrb-brands-menu[open]').forEach((menu) => {
    if (menu !== event.target) menu.open = false;
  });
}, true);
  } catch(e) { console.error(e); }
})();

})();
